// Should stay in sync with observationOptions.mjs

import { OBSERVATION_TYPE } from './observationType';

export const OBSERVATION_OPTIONS = {
  [OBSERVATION_TYPE.NA]: 'N/A',
  [OBSERVATION_TYPE.ATM_OBSERVER]: 'ATM Observer',
  [OBSERVATION_TYPE.ATL_OBSERVER]: 'ATL Observer'
};
